import * as angular from 'angular';
import { ComponentDefinition, Identifier, IValueViewModel } from '../../models';

class IdentifierNameDisplayController implements angular.IComponentController {
    readonly hasGroupName: boolean;
    readonly identifier: IValueViewModel | Identifier;
    readonly isEditMode: boolean;

    static $inject = [];
}

export const wtIdentifierNameDisplay: ComponentDefinition = {
    componentId: 'wtIdentifierNameDisplay',
    controller: IdentifierNameDisplayController,
    template: require('./identifierNameDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        hasGroupName: '<?',
        identifier: '<',
        isEditMode: '<?'
    }
};